import { render, staticRenderFns } from "./RproV1.vue?vue&type=template&id=72cdb28c&scoped=true"
import script from "./RproV1.vue?vue&type=script&lang=js"
export * from "./RproV1.vue?vue&type=script&lang=js"
import style0 from "./RproV1.vue?vue&type=style&index=0&id=72cdb28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cdb28c",
  null
  
)

export default component.exports